import { useReducers } from "../../../shared/hooks/useReducer";
import constants from "../../../shared/constants";
const { REDUCER_TYPE } = constants;

const usePlayerState = () => {
  const {
    provider: appProvider,
    userProfile,
    isInHome,
    toastData,
    playbackError,
    spinningLoaderParams,
    reloadAppFlag,
    featureToggles,
  } = useReducers(REDUCER_TYPE.APP);
  const { recordingsList, manipulatedRecordingParams } = useReducers(REDUCER_TYPE.RECORDING);

  return {
    appProvider,
    userProfile,
    isInHome,
    toastData,
    playbackError,
    spinningLoaderParams,
    reloadAppFlag,
    featureToggles,
    recordingsList,
    manipulatedRecordingParams,
  };
};

export { usePlayerState };
